<div class="container-generic">
  <app-menu [menuModuleEnum]="menuModuleEnum" [menuFunctionalityEnum]="menuFunctionalityEnum"></app-menu>

  <div class="container-body">
    <h1>Notificação de Agravo</h1>
    <div class="white-body">
      <div class="title-notification">
        <div class="title col-6">
          <h3 class="border-green-left-title">{{grievanceNotificationName}}</h3>
        </div>
        <div class="col-12 col-sm-3 col-md-2">
          <button mat-flat-button type="button" color="primary" class=" btn-block" (click)="openPdfInstructions()">
            @if (isLoading == false) {
              <span>Orientações de preenchimento</span>
            }
            @if (isLoading == true) {
              <mat-spinner [diameter]="30" class="mat-spinner-btn"
              ></mat-spinner>
            }
          </button>
        </div>
      </div>
      @if (!this.isFirstLoading && this.listSectionGrievanceNotificationStruct && this.listSectionGrievanceNotificationStruct.length > 0) {
        <form class="form" [formGroup]="model" (ngSubmit)="submit()">
          <div class="col-12 col-sm-6 col-md-3">
            <mat-form-field appearance="outline">
              <mat-label>Número da notificação</mat-label>
              <input matInput type="text" formControlName="guideNumber" maxlength="21"
                oninput="this.value = this.value.replace(/[^0-9]/g, ''); this.value = this.value.replace(/(\..*)\./g, '$1');">
                @if (model.get('guideNumber').invalid) {
                  <mat-error>Preenchimento incorreto</mat-error>
                }
                <mat-hint align="end">
                  {{ model.get('guideNumber').value ? model.get('guideNumber').value.length : 0}}/21
                </mat-hint>
              </mat-form-field>
            </div>
            @for (section of listSectionGrievanceNotificationStruct; track section) {
              <div class="section-content" formArrayName="listFields">
                <h3>{{section.nameSectionGrievanceNotification}}</h3>
                <div class="row">
                  @for (field of section.listFieldsGrievanceNotificationStruct; track field; let i = $index) {
                    <ng-container [formGroupName]="field.indexFormArray">
                      @if (field.idTypeFieldGrievanceNotification === typeFieldGrievanceNotificationEnum.text) {
                        <div class="col-12 col-sm-6 col-lg-4 col-xl-3">
                          @if (field.nameGroupFieldsGrievanceNotification) {
                            <span class="name-group">{{ field.numberOfField}} - {{field.nameGroupFieldsGrievanceNotification}}</span>
                          }
                          @if (!field.nameGroupFieldsGrievanceNotification) {
                            <br>
                            }
                            <mat-form-field appearance="outline">
                              <mat-label [matTooltip]="field.nameFieldGrievanceNotification">{{field.idGroupFieldsGrievanceNotification == null && field.numberOfField ? field.numberOfField + ' -' : ''}} {{ field.nameFieldGrievanceNotification }}</mat-label>
                              <input matInput [formControlName]="field.nameVariableGrievanceNotification" type="text" [maxlength]="field.maxFieldLenght"/>
                              @if (model.get('listFields')['controls'][field.indexFormArray].get(field.nameVariableGrievanceNotification)?.invalid) {
                                <mat-error>Campo
                                obrigatório</mat-error>
                              }
                              <mat-hint align="end">
                                {{ model.get('listFields')['controls'][field.indexFormArray].get(field.nameVariableGrievanceNotification).value ?
                                model.get('listFields')['controls'][field.indexFormArray].get(field.nameVariableGrievanceNotification).value.length : 0}}/{{field.maxFieldLenght}}
                              </mat-hint>
                            </mat-form-field>
                          </div>
                        }
                        @if (field.idTypeFieldGrievanceNotification === typeFieldGrievanceNotificationEnum.number) {
                          <div class="col-12 col-sm-6 col-lg-4 col-xl-3">
                            @if (field.nameGroupFieldsGrievanceNotification) {
                              <span class="name-group">{{ field.numberOfField}} - {{field.nameGroupFieldsGrievanceNotification}}</span>
                            }
                            @if (!field.nameGroupFieldsGrievanceNotification) {
                              <br>
                              }
                              <mat-form-field appearance="outline">
                                <mat-label [matTooltip]="field.nameFieldGrievanceNotification">{{field.idGroupFieldsGrievanceNotification == null && field.numberOfField ? field.numberOfField + ' -' : ''}} {{ field.nameFieldGrievanceNotification }}</mat-label>
                                <input matInput [formControlName]="field.nameVariableGrievanceNotification" type="text" [maxlength]="field.maxFieldLenght"
                                  oninput="this.value = this.value.replace(/[^0-9]/g, ''); this.value = this.value.replace(/(\..*)\./g, '$1');"/>
                                  @if (model.get('listFields')['controls'][field.indexFormArray].get(field.nameVariableGrievanceNotification)?.invalid) {
                                    <mat-error>Campo
                                    obrigatório</mat-error>
                                  }
                                  <mat-hint align="end">
                                    {{ model.get('listFields')['controls'][field.indexFormArray].get(field.nameVariableGrievanceNotification).value ?
                                    model.get('listFields')['controls'][field.indexFormArray].get(field.nameVariableGrievanceNotification).value.length : 0}}/{{field.maxFieldLenght}}
                                  </mat-hint>
                                </mat-form-field>
                              </div>
                            }
                            @if (field.idTypeFieldGrievanceNotification === typeFieldGrievanceNotificationEnum.date) {
                              <div class="col-12 col-sm-6 col-lg-4 col-xl-3">
                                @if (field.nameGroupFieldsGrievanceNotification) {
                                  <span class="name-group">{{ field.numberOfField}} - {{field.nameGroupFieldsGrievanceNotification}}</span>
                                }
                                @if (!field.nameGroupFieldsGrievanceNotification) {
                                  <br>
                                  }
                                  <mat-form-field appearance="outline">
                                    <mat-label [matTooltip]="field.nameFieldGrievanceNotification">{{field.idGroupFieldsGrievanceNotification == null && field.numberOfField ? field.numberOfField + ' -' : ''}} {{ field.nameFieldGrievanceNotification }}</mat-label>
                                    <input matInput inputmode="text" type="text" [mask]="masks.date" placeholder="dd/mm/aaaa"
                                      [formControlName]="field.nameVariableGrievanceNotification"
                                      (change)="verifyDate(field.nameVariableGrievanceNotification, field.indexFormArray)" />
                                      @if (model.get('listFields')['controls'][field.indexFormArray].get(field.nameVariableGrievanceNotification).hasError(invalidDate)) {
                                        <mat-error
                                          >Data
                                        inválida</mat-error>
                                      }
                                    </mat-form-field>
                                  </div>
                                }
                                @if (field.idTypeFieldGrievanceNotification === typeFieldGrievanceNotificationEnum.select) {
                                  <div class="col-12 col-sm-6 col-lg-4 col-xl-3">
                                    @if (field.nameGroupFieldsGrievanceNotification) {
                                      <span class="name-group">{{ field.numberOfField}} - {{field.nameGroupFieldsGrievanceNotification}}</span>
                                    }
                                    @if (!field.nameGroupFieldsGrievanceNotification) {
                                      <br>
                                      }
                                      <mat-form-field appearance="outline">
                                        <mat-label [matTooltip]="field.nameFieldGrievanceNotification">{{field.idGroupFieldsGrievanceNotification == null && field.numberOfField ? field.numberOfField + ' -' : ''}} {{ field.nameFieldGrievanceNotification }}</mat-label>
                                        <mat-select [formControlName]="field.nameVariableGrievanceNotification">
                                          <mat-option [value]="null">
                                            Selecione...
                                          </mat-option>
                                          @for (option of listLookupValueGrievanceNotification | filterLookupGrievanceNotification:field.idLookupTypeGrievanceNotification; track option) {
                                            <mat-option
                                              [value]="option" (click)="addComplement(field, option, field.indexFormArray)">
                                              {{ option.code }} - {{ option.name }}
                                            </mat-option>
                                          }
                                        </mat-select>
                                        @if (model.get('listFields')['controls'][field.indexFormArray].get(field.nameVariableGrievanceNotification)?.invalid) {
                                          <mat-error>Campo
                                          obrigatório</mat-error>
                                        }
                                      </mat-form-field>
                                    </div>
                                  }
                                  @if (field.idTypeFieldGrievanceNotification === typeFieldGrievanceNotificationEnum.multiselect) {
                                    <div class="col-12 col-sm-6 col-lg-4 col-xl-3">
                                      @if (field.nameGroupFieldsGrievanceNotification) {
                                        <span class="name-group">{{ field.numberOfField}} - {{field.nameGroupFieldsGrievanceNotification}}</span>
                                      }
                                      @if (!field.nameGroupFieldsGrievanceNotification) {
                                        <br>
                                        }
                                        <mat-form-field appearance="outline">
                                          <mat-label [matTooltip]="field.nameFieldGrievanceNotification">{{field.idGroupFieldsGrievanceNotification == null && field.numberOfField ? field.numberOfField + ' -' : ''}} {{ field.nameFieldGrievanceNotification }}</mat-label>
                                          <mat-select [formControlName]="field.nameVariableGrievanceNotification" multiple
                                            (selectionChange)="addComplementMultiselect(field, $event.value, field.indexFormArray)">
                                            @for (option of listLookupValueGrievanceNotification | filterLookupGrievanceNotification:field.idLookupTypeGrievanceNotification; track option) {
                                              <mat-option
                                                [value]="option">
                                                {{ option.code }} - {{ option.name }}
                                              </mat-option>
                                            }
                                          </mat-select>
                                          @if (model.get('listFields')['controls'][field.indexFormArray].get(field.nameVariableGrievanceNotification)?.invalid) {
                                            <mat-error>Campo obrigatório</mat-error>
                                          }
                                        </mat-form-field>
                                      </div>
                                    }
                                    @if (model.get('listFields')['controls'][field.indexFormArray].get('complement')) {
                                      <div class="col-12 col-sm-6 col-lg-4 col-xl-3">
                                        <br>
                                          <mat-form-field appearance="outline">
                                            <mat-label [matTooltip]="field.nameFieldGrievanceNotification">{{ field.numberOfField }} - Complemento</mat-label>
                                            <input matInput formControlName="complement" type="text" [maxlength]="field.maxFieldLenght"/>
                                            @if (model.get('listFields')['controls'][field.indexFormArray].get('complement')?.invalid) {
                                              <mat-error>Campo obrigatório</mat-error>
                                            }
                                            <mat-hint align="end">
                                              {{ model.get('listFields')['controls'][field.indexFormArray].get('complement').value ?
                                              model.get('listFields')['controls'][field.indexFormArray].get('complement').value.length : 0}}/{{field.maxFieldLenght}}
                                            </mat-hint>
                                          </mat-form-field>
                                        </div>
                                      }
                                    </ng-container>
                                  }
                                </div>
                              </div>
                            }
                            <div class="row">
                              <div class="col-12 col-sm-3 col-md-2">
                                <button mat-flat-button type="button" color="accent" class=" btn-block" (click)="cancel()">
                                  @if (isLoading == false) {
                                    <span>Voltar</span>
                                  }
                                  @if (isLoading == true) {
                                    <mat-spinner [diameter]="30" class="mat-spinner-btn"
                                    ></mat-spinner>
                                  }
                                </button>
                              </div>
                              @if (!readOnly) {
                                <div class="col-12 col-sm-3 col-md-2">
                                  <button mat-flat-button type="submit" color="primary" class=" btn-block">
                                    @if (isLoading == false) {
                                      <span>Salvar</span>
                                    }
                                    @if (isLoading == true) {
                                      <mat-spinner [diameter]="30" class="mat-spinner-btn"
                                      ></mat-spinner>
                                    }
                                  </button>
                                </div>
                              }
                              @if (!readOnly) {
                                <div class="col-12 col-sm-3 col-md-2">
                                  <button mat-flat-button type="button" color="primary" class=" btn-block" (click)="finalizeFormFilling(this.grievanceNotificationStatusEnum.completa)">
                                    @if (isLoading == false) {
                                      <span>Salvar e finalizar</span>
                                    }
                                    @if (isLoading == true) {
                                      <mat-spinner [diameter]="30" class="mat-spinner-btn"
                                      ></mat-spinner>
                                    }
                                  </button>
                                </div>
                              }
                            </div>
                          </form>
                        }

                        @if (isFirstLoading) {
                          <app-loading-list></app-loading-list>
                        }
                        @if (!this.isLoading && !this.isFirstLoading && (listSectionGrievanceNotificationStruct == undefined || listSectionGrievanceNotificationStruct.length == 0)) {
                          <app-empty-list [message]="'Erro ao buscar informações'"></app-empty-list>
                        }
                      </div>
                    </div>
                  </div>